import React from 'react';
import { withStyles } from 'material-ui/styles';
import { Typography } from 'material-ui';
import { translate } from 'react-i18next';

/**
 * Este objeto renderiza el DTO Room. de una llamada del estilo
 * /v1/reservation/U18X000055X01
 */
/*
"rooms": [
    {
        "order": "1",
        "adults": "2",
        "kids": [],
        "mealPlan": "MP",
        "service": {
            "code": "S0095",
            "description": "Doble Std MP"
        },
        "catalogue": {
            "code": "643",
            "name": "GENERAL 18"
        },
        "conceptCode": "2000"
    }
]
*/

const styles = theme => ({

    modifiedData: {
        fontWeight: 300,
        fontSize: '14px'
    },
    modifiedDataColor: {
        fontWeight: 300,
        fontSize: '14px',
        color: theme.palette.primary.main
    }
});

class RoomDetail extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const { classes, room } = this.props;
        let serviceDesc = this.props && this.props.name ? this.props.name : this.props.service;
        if (serviceDesc && serviceDesc.description) {
            serviceDesc = serviceDesc.description;
        }
        let style = this.props.diff ?
            classes.modifiedDataColor :
            classes.modifiedData;
        let num = 1;
        let spd = '';
        if (room && room.subMealPlanDescription) {
            spd = ' - ' + room.subMealPlanDescription;
        }
        if (room && room.quantity) {
            num = room.quantity;
        }
        return (
            <Typography className={style}>
                {num} x {String(serviceDesc)} - <i>{this.props.description} {spd}</i>
            </Typography>
        );
    }
}

export default translate('translations')(withStyles(styles, { withTheme: true })(RoomDetail));



// WEBPACK FOOTER //
// ./src/components/Reservation/RoomDetail.js